import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import { Field, FieldArray } from "formik";
import { CustomErrorMessage } from "../../../../components/FormComponents/CustomErrorMessage";
import { hasError } from "../../../../components/FormComponents/utils";
import HorizontalRule from "../../../../components/HorizontalRule/HorizontalRule";
import DeleteIcon from '@mui/icons-material/Delete';
import { Dispatch, KeyboardEventHandler, SetStateAction, useCallback, useEffect, useRef, useState } from "react";
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";

import AddIcon from '@mui/icons-material/Add';
import { IPeca } from "../../../Obras/newObra/IObra";

export function OrcamentacaoPecasForm({
    formikProps,
    saveCurrentState,
    pecasArrayHelpers,
    materiais,
    setPecasUpdatedIncrementer
}: {
    saveCurrentState: any,
    formikProps: any,
    pecasArrayHelpers: any,
    materiais: any[],
    setPecasUpdatedIncrementer: Dispatch<SetStateAction<number>>
}) {

    const { values, errors, touched, handleChange, setFieldValue } = formikProps;
    const [pecas, setPecas] = useState<Partial<IPeca>[]>(pecasArrayHelpers ? pecasArrayHelpers.form.values.pecasOrcamentadas : []);
    const pecasRef = useRef(null);

    const getReference = useCallback((ref: string) => {
        const splittedRef = ref.split('-');
        if (splittedRef.length) {
            const parsedInt = parseInt(splittedRef[splittedRef.length - 1]);
            if (parsedInt) {
                splittedRef[splittedRef.length - 1] = (parsedInt + 1).toString();
                return splittedRef.join('-');
            }
        }
        return ref;
    }, [])





    const addNewPeca = () => {
        const lastPeca = values.pecasOrcamentadas[values.pecasOrcamentadas.length - 1];
        const reference = lastPeca ? getReference(lastPeca.reference) : '';
        const newPeca = { reference, material: lastPeca?.material ?? '', amount: lastPeca?.amount ?? 0, unitPrice: lastPeca?.unitPrice ?? 0, margem: lastPeca?.margem ?? 0, tempoPeca: lastPeca?.tempoPeca ?? 0 };
        pecasArrayHelpers.push(newPeca)
        // updateOrcamentoValue();
        setPecas([...pecas, newPeca]);
        saveCurrentState(values);
    }

    const deletePeca = (idx: number) => {
        pecasArrayHelpers.remove(idx);
        setPecas(pecas.filter((_, i) => idx !== i))
        // updateOrcamentoValue();
    }

    const eventListenerCb = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            addNewPeca();
            return;
        }
    }


    return (<div className="p-2 pt-1 mt-1 hover:bg-red-300 hover:bg-opacity-20 rounded-md" ref={pecasRef} tabIndex={0} onKeyDown={eventListenerCb}>
        <h2 className="font-bold mb-4 mt-3">Peças</h2>
        {values?.pecasOrcamentadas && values.pecasOrcamentadas.length > 0 ? (values.pecasOrcamentadas.map((p: IPeca, idx: number) =>
            <div key={idx} className="border border-red-200 rounded mb-1">
                <div
                    key={idx}
                    className={`flex w-full justify-between items-center border-md p-2`}>
                    <div className="flex justify-between items-center">

                        <Field
                            className={"w-1/4"}
                            name={`pecasOrcamentadas.${idx}.reference`}
                            as={TextField}
                            type={"text"}
                            size="small"
                            error={hasError({ errors, touched, name: `pecasOrcamentadas.${idx}.reference` as any })}
                            variant={'outlined'}
                            label={'Referência'} />
                        <CustomErrorMessage name={`pecasOrcamentadas.${idx}.reference`} />


                        <Field
                            className={"w-1/4"}
                            name={`pecasOrcamentadas.${idx}.material`}
                            value={values.pecasOrcamentadas[idx].material}
                            as={Select}
                            margin={"dense"}
                            variant={'outlined'}
                            label={'Material'}
                            placeholder={'Material'}
                            renderValue={(item: any) => item.reference}
                        >
                            {materiais?.map((c: any) => <MenuItem key={c.id} value={c as any}>{c.reference}</MenuItem>)}
                        </Field>

                        <CustomErrorMessage name={`pecasOrcamentadas.${idx}.material`} />

                        <Field
                            className={"w-1/8"}
                            name={`pecasOrcamentadas.${idx}.amount`}
                            as={TextField}
                            type={"number"}
                            size="small"
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                handleChange(e);
                                const p = pecas;
                                p[idx].amount = parseInt(e.target.value);
                                setPecas([...p]);
                                setPecasUpdatedIncrementer((prev: number) => prev + 1);
                            }}
                            error={hasError({ errors, touched, name: `pecasOrcamentadas.${idx}.amount` as any })}
                            variant={'outlined'}
                            label={'Quantidade'} />
                        <CustomErrorMessage name={`pecasOrcamentadas.${idx}.amount`} />

                        <Field
                            className={"w-1/6"}
                            name={`pecasOrcamentadas.${idx}.unitPrice`}
                            as={TextField}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                handleChange(e);
                                const p = pecas;
                                p[idx].unitPrice = parseFloat(e.target.value);
                                setPecas([...p]);
                                setPecasUpdatedIncrementer((prev: number) => prev + 1);
                            }}
                            type={"number"}
                            size="small"
                            error={hasError({ errors, touched, name: `pecasOrcamentadas.${idx}.unitPrice` as any })}
                            variant={'outlined'}
                            label={'Preço unid.'} />
                        <CustomErrorMessage name={`pecasOrcamentadas.${idx}.unitPrice`} />

                        <Field
                            className={"w-1/8"}
                            name={`pecasOrcamentadas.${idx}.margem`}
                            as={TextField}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                handleChange(e);
                                const p = pecas;
                                p[idx].margem = parseFloat(e.target.value);
                                setPecas([...p]);
                            }}
                            type={"number"}
                            size="small"
                            error={hasError({ errors, touched, name: `pecasOrcamentadas.${idx}.margem` as any })}
                            variant={'outlined'}
                            label={'Margem (%)'} />
                        <CustomErrorMessage name={`pecasOrcamentadas.${idx}.margem`} />

                        <Field
                            className={"w-1/8"}
                            name={`pecasOrcamentadas.${idx}.tempoPeca`}
                            as={TextField}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                handleChange(e);
                                const p = pecas;
                                p[idx].tempoPeca = parseFloat(e.target.value);
                                setPecas([...p]);
                            }}
                            type={"number"}
                            size="small"
                            error={hasError({ errors, touched, name: `pecasOrcamentadas.${idx}.tempoPeca` as any })}
                            variant={'outlined'}
                            label={'Tempo peça'} />
                        <CustomErrorMessage name={`pecasOrcamentadas.${idx}.tempoPeca`} />


                    </div>
                    <DeleteIcon className="text-red-400 cursor-pointer ml-3" onClick={() => deletePeca(idx)} />

                </div>

            </div>
        )) : null}
        <CustomButtonSimple className="mt-4 h-8" text="Adicionar peça" Icon={AddIcon} onClick={addNewPeca} />
    </div>)

}